const moneyFormatter = new Intl.NumberFormat('pt-br', {
	style: 'currency',
	currency: 'BRL',
})

export { moneyFormatter }
